import {
  GET_ALL_BILLING,
  ADD_BILLING,
  UPDATE_BILLING,
} from "../../types/index";
const BillingAddressReducer = (state, action) => {
  switch (action.type) {
    // Case que consulta 
    case GET_ALL_BILLING:
      return {
        ...state,
        billingAddress: action.payload,
        success: true,
        ErrorsApi: [],
      };
    // Case que agrega 
    case ADD_BILLING:
      return {
        ...state,
        billingAddress: [action.payload, ...state.billingAddress],
      };
    // Case que edita 
    case UPDATE_BILLING:
      return {
        ...state,
        ErrorsApi: [],
        billingAddress: state.billingAddress.map((billingAddres) => {
          if (billingAddres.id === action.payload.id) {
            billingAddres = action.payload;
          }
          return billingAddres;
        }),
      };
    default:
      return state;
  }
};

export default BillingAddressReducer;
